import type { GrantScope, InviteScope } from '../../lib/sharing-types';

export const shareKeys = {
  access: (s: GrantScope) => ['access', s.type, s.id] as const,
  invitations: (s: InviteScope) => ['invitations', s.type, s.id] as const,
  links: (boardId: string) => ['share-links', boardId] as const,
  shared: ['shared-with-me'] as const,
};
